/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-10-11 14:30:47
 * @LastEditors: 倪国晓
 * @LastEditTime: 2022-10-25 15:07:35
 */
import ColumnTypes from '@/utils/ColumnTypes';
import { DrInfo, TzInfo, Address, DrContacts } from './renderHeader';
// 达人信息
const talentInfo = {
	key: 'talentInfo',
	type: () => import('./tableCell/drInfoCell'),
	renderHeader: DrInfo,
	width: '300',
};
//达人联系人
const talentContacts = {
	key: 'talentContacts',
	type: () => import('./tableCell/drContactsCell'),
	renderHeader: DrContacts,
};
//收货地址
const receiverAddress = {
	key: 'address',
	renderHeader: Address,
	type: () => import('./tableCell/deliveryAddressCell.vue'),
	width: '240',
};
//团长信息
const tzInfo = {
	label: '团长信息',
	key: 'institution_name',
	type: ColumnTypes.TextCell,
	renderHeader: TzInfo,
	width: '300',
};
//关联达人
const relatedTalent = {
	label: '关联达人',
	key: 'relatedTalent',
	type: () => import('./tableCell/relativedDr'),
};
//操作
const operation = {
	label: '操作',
	key: 'operation',
	type: ColumnTypes.ButtonsCell,
	width: '100',
};
export const talentColumns = [talentInfo, talentContacts, receiverAddress, operation]; //达人
export const tzColumns = [tzInfo, receiverAddress, relatedTalent, operation]; //团长
